import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache'
import 'sweetalert2/dist/sweetalert2.min.css';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
const nonce = '89d269334fa30521b7e4614402ca44133c3b6f361201ef51c0c2f19659a3a2be';
const cache = createCache({
    key: 'css',
    nonce: nonce
});
root.render(
    <React.StrictMode>
        <CacheProvider value={cache}>
            <App />
        </CacheProvider>
    </React.StrictMode>
);
